import * as styles from './modal.module.css';
import { Cancel01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';
import { useMobile } from '../../../../hooks/useMobile';

type Props = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
};

const ANIM_MS = 220;

export default function Modal({ children, isOpen, onClose }: Props) {
  const isMobile = useMobile();
  const [mounted, setMounted] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      const t = window.setTimeout(() => setMounted(true), 0);
      return () => window.clearTimeout(t);
    }

    const t = window.setTimeout(() => setMounted(false), ANIM_MS);
    return () => window.clearTimeout(t);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    const scrollBarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = `${scrollBarWidth}px`;

    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, [isOpen]);

  if (!mounted) return null;

  return createPortal(
    <div
      className={`${styles.modal_background} ${isOpen ? styles.open : ''}`}
      onMouseDown={e => {
        if (e.target === e.currentTarget) {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
      onClick={e => {
        if (e.target === e.currentTarget) {
          e.stopPropagation();
          onClose();
        }
      }}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`${styles.modal} ${isMobile ? styles.modal_mobile : ''}`}
        onMouseDown={e => e.stopPropagation()}
        onClick={e => e.stopPropagation()}
      >
        <button
          className={styles.cancel}
          onClick={onClose}
          type="button"
          aria-label="Закрыть"
        >
          <HugeiconsIcon size={20} icon={Cancel01Icon} />
        </button>
        {children}
      </div>
    </div>,
    document.body
  );
}
